module.exports = __webpack_public_path__ + "static/media/mit.8f42a918.png";